const Config = require('~/config/default.env').default;
import errorMessageSwitcher from '@/shared/mixins/ErrorMessageSwitcher';
import Auth from './auth';
// import Content from '@/app/shared/services/content';
import { isEmpty } from 'lodash';

export default {
  state: {
    method: '',
    scope: '',
    error: '',
    maxReached: false,
    code: '',
    loading: false,
    interval: {
      function: '',
      count: 30,
    },
    verification: {
      phone: '',
      email: '',
      isCorrectNumber: false,
    },
    changeNumber: {
      newNumber: '',
      fromPhoneNotCorrect: false,
    },
    forgetPassword: {
      mode: 'phone',
      phone: '',
      email: '',
      emailSuccess: false,
      userId: '',
    },
    quickRegistration: {
      mode: 'phone',
      phone: '',
      email: '',
      hash: '',
    },
    enableCheck: {
      methods: ['sms', 'whatsapp', 'email'],
      result: [],
      loading: false,
    },
    offlineRegist: {
      mode: 'phone',
      phone: '',
      user_id: '',
    },
    isOtpSent: false,
    isOtpVerified: false,
    country: [],
    userCountry: {},
  },
  mutations: {
    setNewChangeNumber(state, value) {
      state.changeNumber.newNumber = value;
    },
    setOtpInterval(state) {
      const interval = state.interval;
      if (interval.count) {
        interval.function = setInterval(() => {
          interval.count -= 1;
          if (interval.count === 0) {
            clearInterval(interval.function);
          }
        }, 1000);
      }
    },
    resetOtpInterval(state) {
      const interval = state.interval;
      clearInterval(interval.function);
      interval.count = 30;
    },
    setOtpError(state, value) {
      let time = 0;
      state.error = value;
      const intervalError = setInterval(() => {
        time++;
        if (time === 5) {
          clearInterval(intervalError);
          state.error = '';
        }
      }, 1000);
    },
    setOtpScope(state, value) {
      state.scope = value;
    },
    setOtpMethod(state, value) {
      state.method = value;
    },
    setVerification(state, value) {
      state.verification = Object.assign(state.verification, value);
    },
    setOtpCode(state, value) {
      state.code = value;
    },
    setForgetPassword(state, value) {
      state.forgetPassword = Object.assign(state.forgetPassword, value);
    },
    setOfflineRegist(state, value) {
      state.offlineRegist = Object.assign(state.offlineRegist, value);
    },
    setUserId(state, value) {
      state.forgetPassword.userId = value;
    },
    setLoading(state, value) {
      state.loading = value;
    },
    setEmailSuccess(state, value) {
      state.forgetPassword.emailSuccess = value;
    },
    setFromPhoneNotCorrect(state, value) {
      state.changeNumber.fromPhoneNotCorrect = value;
    },
    changeIsCorrectNumber(state, value) {
      state.verification.isCorrectNumber = value;
    },
    setIsOtpSent(state, value) {
      state.isOtpSent = value;
    },
    setIsOtpVerified(state, value) {
      state.isOtpVerified = value;
    },
    setQuickRegistration(state, data) {
      state.quickRegistration = Object.assign(state.quickRegistration, data);
    },
    setEnableCheck(state, { key, value }) {
      if (Object.prototype.hasOwnProperty.call(state.enableCheck, key)) {
        state.enableCheck[key] = value;
      }
    },
    setCountry(state, value) {
      state.country = value;
    },
    saveCountry(state, value) {
      state.userCountry = value;
    },
    setMaxReached(state, value) {
      state.maxReached = value;
    },
  },
  actions: {
    selectOtpMethod({ state, dispatch, commit, rootState }, method) {
      // back to input email/phone address
      // when change otp method after interval is cleared
      // for forget password scope
      if (state.scope === 'forget-password' && state.method) {
        if (!rootState.loggedin) {
          commit(
            'setDataModal',
            {
              modalName: 'loginPage',
              value: 3,
            },
            { root: true }
          );
        }
        if (rootState.modal.isModalShow.otpCode) {
          commit('toggleModalGlobalState', { modalName: 'otpCode' }, { root: true });
        }
        commit('toggleModalGlobalState', { modalName: 'forgetPassword' }, { root: true });
        commit('setForgetPassword', { mode: method });
        return;
      }
      // back to input email/phone address
      // when change otp method after interval is cleared
      // for quick registration scope
      if (state.scope === 'quick-registration' && state.isOtpSent) {
        if (rootState.modal.isModalShow.otpCode) {
          commit('toggleModalGlobalState', { modalName: 'otpCode' }, { root: true });
        }
        commit('setQuickRegistration', {
          mode: method,
        });
        return;
      }
      commit('setOtpMethod', method);
      dispatch('sendOtp');
    },
    setSendOtpPayload({ state }) {
      const payload = new Object();
      const urlQueries = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
      });

      payload['mode'] = state.method;
      if (state.scope && state.scope === 'verification') {
        payload['phone_code'] = state.userCountry.phone_code ? state.userCountry.phone_code : '+62';
        payload['entity'] = 'phone_no';
      }
      if (state.scope && state.scope === 'forget-password') {
        state.forgetPassword.mode === 'phone'
          ? (payload['phone_no'] = state.forgetPassword.phone)
          : (payload['email'] = state.forgetPassword.email);
        payload['phone_code'] = state.forgetPassword.phone_code;
      }
      if (state.scope && state.scope === 'change-number') {
        payload['phone_no'] = state.changeNumber.newNumber;
        payload['entity'] = 'phone_no';
        payload['phone_code'] = state.userCountry.phone_code ? state.userCountry.phone_code : '+62';
      }
      if (state.scope && state.scope === 'quick-registration') {
        if (state.quickRegistration.mode === 'phone') {
          payload['entity'] = 'phone_no';
          payload['entity_value'] = state.quickRegistration.phone;
          payload['phone_code'] = state.userCountry.phone_code ? state.userCountry.phone_code : '+62';
        }
        if (state.quickRegistration.mode === 'email') {
          payload['entity'] = 'email';
          payload['entity_value'] = state.quickRegistration.email;
        }
        if (urlQueries.user_id || state.offlineRegist.user_id) {
          payload['user_id'] = urlQueries.user_id;
        }
        if (urlQueries.hash) {
          payload['hash'] = urlQueries.hash;
        }
      }
      if (state.scope && state.scope === 'registered_sociolla_store') {
        payload['phone_no'] = state.offlineRegist.phone;
        payload['user_id'] = state.offlineRegist.user_id;
        payload['entity'] = 'phone_no';
      }
      return payload;
    },
    setSendOtpEndpoint({ state }) {
      if (state.scope && state.scope === 'forget-password') {
        return state.scope;
      }
      if (state.scope && state.scope === 'quick-registration') {
        return 'login/otp/request';
      }
      return 'otp/code';
    },
    setVerifyOtpPayload({ state }) {
      const payload = new Object();
      payload['mode'] = state.method;
      payload['code'] = state.code;
      const urlQueries = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
      });

      if (state.scope && state.scope === 'verification') {
        payload['phone_code'] = state.userCountry.phone_code ? state.userCountry.phone_code : '+62';
        payload['entity'] = 'phone_no';
      }
      if (state.scope && state.scope === 'forget-password') {
        payload['user_id'] = state.forgetPassword.userId;
        payload['entity'] = 'password';
      }
      if (state.scope && state.scope === 'change-number') {
        payload['phone_no'] = state.changeNumber.newNumber;
        payload['entity'] = 'phone_no';
        payload['phone_code'] = state.userCountry.phone_code ? state.userCountry.phone_code : '+62';
      }
      if (state.scope && state.scope === 'quick-registration') {
        if (state.quickRegistration.mode === 'phone' && (state.method === 'sms' || state.method === 'whatsapp')) {
          payload['entity'] = 'phone_no';
          payload['entity_value'] = state.quickRegistration.phone;
          payload['phone_code'] = state.userCountry.phone_code ? state.userCountry.phone_code : '+62';
        }
        if (state.quickRegistration.mode === 'email') {
          payload['entity'] = 'email';
          payload['entity_value'] = state.quickRegistration.email;
        }
        if (urlQueries.user_id) {
          payload['user_id'] = urlQueries.user_id;
        }
        if (urlQueries.hash) {
          payload['hash'] = urlQueries.hash;
        }
      }
      if (state.scope && state.scope === 'registered_sociolla_store') {
        if (state.offlineRegist.mode === 'phone' && (state.method === 'sms' || state.method === 'whatsapp')) {
          payload['entity'] = 'phone_no';
          payload['entity_value'] = state.offlineRegist.phone;
          payload['phone_code'] = state.userCountry.phone_code ? state.userCountry.phone_code : '+62';
          payload['user_id'] = state.offlineRegist.user_id;
        }
      }
      return payload;
    },
    setVerifyOtpEndpoint({ state }) {
      if (state.scope === 'quick-registration' || state.scope === 'registered_sociolla_store') {
        return 'login/otp';
      }
      return 'otp/verify';
    },
    otpServiceEnableCheck({ commit }) {
      commit('setEnableCheck', { key: 'loading', value: true });
      return axios
        .get(`${Config.MS_SOCO_PUBLIC_API_URL}/feature-toggles`, {
          params: { filter: { feature_name: { $in: ['otp_sms', 'otp_whatsapp', 'otp_email'] } } },
        })
        .then((response) => {
          return response.data.data;
        })
        .then((resp) => {
          commit('setEnableCheck', { key: 'result', value: resp });
          const filter = resp.filter((check) => check.isEnable);
          if (!filter.length) {
            commit('changeIsCorrectNumber', true);
          }
        })
        .catch(({ response }) => {
          console.error(response.errorCode);
        })
        .finally(() => {
          commit('setEnableCheck', { key: 'loading', value: false });
        });
    },
    async sendOtp({ dispatch, commit, state }) {
      const payload = await dispatch('setSendOtpPayload');
      const endpoint = await dispatch('setSendOtpEndpoint');

      commit('setLoading', true);
      return axios
        .post(`${Config.MS_SOCO_PUBLIC_API_URL}/auth/${endpoint}`, payload)
        .then((response) => {
          commit('resetOtpInterval');
          commit('setOtpInterval');
          if (response.data.success) {
            if (state.scope === 'forget-password') {
              commit('setUserId', response.data.data.user_id);
            }
            commit('setIsOtpSent', true);
            return true;
          }
        })
        .catch((error) => {
          if (error.response.data.errorCode === 'OTP_MAXIMUM') {
            commit('setMaxReached', true);
          }
          if (
            state.scope === 'forget-password' &&
            error.response.data.errorCode === 'UNFINISH_QUICK_REGISTER' &&
            error.response.status === 422
          ) {
            commit('setIsQuickRegisterLoginError', true, { root: true });
            return false;
          }
          const err = errorMessageSwitcher(error.response.data.errorCode);
          commit('setOtpError', err);
          this._vm.$toasted.global.error(err);
          if (
            state.scope === 'forget-password' &&
            error.response.data.errorCode === 'OTP_MAXIMUM' &&
            error.response.status === 422
          ) {
            commit('setIsOtpSent', false);
            commit(
              'setDataModal',
              {
                modalName: 'loginPage',
                value: 3,
              },
              { root: true }
            );
          }
          return false;
        })
        .finally(() => {
          commit('setLoading', false);
        });
    },
    async verifyOtp({ dispatch, commit, rootState, state }, vm) {
      const payload = await dispatch('setVerifyOtpPayload');
      const endpoint = await dispatch('setVerifyOtpEndpoint');

      commit('setLoading', true);
      return axios
        .post(`${Config.MS_SOCO_PUBLIC_API_URL}/auth/${endpoint}`, payload)
        .then((response) => {
          if (response.data.success) {
            const updateData = new Object();
            // update verified status
            state.method === 'sms' || state.method === 'whatsapp'
              ? (updateData['is_verified_phone'] = true)
              : (updateData['is_verified_email'] = true);
            // update user phone
            if (state.scope === 'change-number') {
              updateData['phone_no'] = state.changeNumber.newNumber;
              updateData['phone_code'] = state.userCountry.phone_code ? state.userCountry.phone_code : '+62';
            }
            if (!isEmpty(rootState.loginWithSocoQueries)) {
              return Auth.authorizeApp({ need_login: false }, vm);
            } else {
              if (!rootState.userProfile) {
                axios.get(Config.MS_ACCOUNTS_API_URL + '/user/me').then((response) => {
                  commit('userProfile', response.data.data, { root: true });
                });
              } else {
                commit('userProfile', Object.assign(rootState.userProfile, updateData), { root: true });
              }
            }
            return true;
          }
        })
        .catch((error) => {
          const err = errorMessageSwitcher(error.response.data.errorCode);
          commit('setOtpError', err);
          return false;
        })
        .finally(() => {
          commit('setLoading', false);
        });
    },
    async sendOtpAgain({ dispatch, state }) {
      const send = await dispatch('sendOtp');
      if (send) {
        setTimeout(() => {
          let prefix = state.method;
          // let suffix = state.method;
          if (state.method === 'WhatsApp' || state.method === 'whatsapp') {
            prefix = 'WhatsApp';
          } else if (state.method === 'sms') {
            prefix = 'SMS';
            // suffix = 'inbox';
          } else {
            prefix = 'Email';
          }
          this._vm.$toasted.global.show(`Verification code sent. Check your ${prefix}`);
        }, 1000);
      }
    },
    async changeNumberVerification({ state, dispatch, commit, rootState }, phone) {
      const phone_no = phone;
      const phone_code = (rootState.otp && rootState.otp.userCountry && rootState.otp.userCountry.phone_code) || '+62';
      if (state.scope === 'forget-password') {
        const verified = await dispatch('verifiedPhoneCheck', { phone_no, phone_code });
        if (verified) {
          commit('setForgetPassword', { phone: phone_no });
          dispatch('sendOtp').then((success) => {
            if (!success) {
              commit('setOtpScope', 'forget-password');
            }
          });
          // hide change number modal
          if (rootState.modal.isModalShow.changeNumber) {
            commit('toggleModalGlobalState', { modalName: 'changeNumber' }, { root: true });
          }
        }
      }
      if (
        state.scope === 'verification' ||
        state.scope === 'change-number' ||
        state.scope === 'registered_sociolla_store'
      ) {
        const available = await dispatch('checkPhoneNumberAvailability', { phone_no, phone_code });
        const checkPhoneSuccess = available.success;

        if (checkPhoneSuccess) {
          if (state.scope === 'registered_sociolla_store') {
            commit('setOtpScope', 'registered_sociolla_store');
            commit('setOfflineRegist', { phone: phone_no });
          } else {
            commit('setOtpScope', 'change-number');
          }
          commit('setNewChangeNumber', phone_no);
          commit('setMaxReached', false);
          // if (state.userCountry && state.userCountry.phone_code) {
          //   commit('setOtpMethod', 'whatsapp');
          //   dispatch('sendOtp');
          // } else {
          commit('setIsOtpSent', false);
          commit('setOtpMethod', '');
          // }
          // dispatch('sendOtp')
          // .then((success) => {
          //     if (!success) {
          //         commit('setOtpScope', 'verification')
          //     }
          // })
          // hide change number modal
          if (rootState.modal.isModalShow.changeNumber) {
            commit('toggleModalGlobalState', { modalName: 'changeNumber' }, { root: true });
          }
          // show otp code modal after change number
          // directly in edit profile
          return true;
        } else {
          const err = errorMessageSwitcher(available.errorCode || 'Phone number is not registered');
          this._vm.$toasted.global.error(err);
          return false;
        }
      }
    },
    verifiedPhoneCheck({ rootState }, phone) {
      const { phone_no, phone_code } = phone;
      return axios
        .get(`${Config.MS_SOCO_PUBLIC_API_URL}/auth/phone/check`, {
          params: {
            filter: {
              phone_no,
              phone_code,
            },
          },
        })
        .then((response) => {
          if (response.data.success) {
            let err = '';
            if (rootState.loggedin) {
              err = errorMessageSwitcher('UNVERIFIED_PHONE_LOGGED_IN');
            }
            this._vm.$toasted.global.error(err || 'Phone number is not registered');
            return !response.data.success;
          }
        })
        .catch((error) => {
          if (error.response.data.errorCode === 'ALREADY_TAKEN') {
            return !error.response.data.success;
          }
          const err = errorMessageSwitcher(error.response.data.errorCode);
          this._vm.$toasted.global.error(err);
          return error.response.data.success;
        });
    },
    verifiedPhoneCheckOfflineRegist({ rootState }, phone) {
      const { phone_no, phone_code } = phone;
      return axios
        .get(`${Config.MS_SOCO_PUBLIC_API_URL}/auth/phone/check`, {
          params: {
            filter: {
              phone_no,
              phone_code,
              is_new_response: true,
            },
          },
        })
        .then((response) => {
          if (response.data.success) {
            if (!response.data.data.is_verified_phone && response.data.data.is_registered_offline) {
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        })
        .catch((error) => {
          return false;
        });
    },
    checkPhoneNumberAvailability(_, phone) {
      const { phone_no, phone_code } = phone;
      return axios
        .get(`${Config.MS_SOCO_PUBLIC_API_URL}/auth/phone/check`, {
          params: {
            filter: {
              phone_no,
              phone_code,
              is_new_response: true,
            },
          },
        })
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          return error.response.data;
        });
    },
    submitOtp({ state, commit, dispatch, rootState }, vm) {
      dispatch('verifyOtp', vm).then((response) => {
        if (response) {
          commit(
            'setDataModal',
            {
              modalName: 'loginPage',
              value: 0,
            },
            { root: true }
          );
          if (rootState.modal.isModalShow.otpCode) {
            commit('toggleModalGlobalState', { modalName: 'otpCode' }, { root: true });
          }
          if (rootState.modal.loginPage.data === 4 && state.scope !== 'registered_sociolla_store') {
            vm.$toasted.global.show('Verifikasi berhasil');
            vm.$router.push('/');
          }
          if (state.scope === 'quick-registration') {
            const userProfile = vm.$store.state.userProfile;
            if (userProfile && userProfile.user_name) {
              vm.$toasted.global.error('Akun sudah terdaftar');
              commit('loggedIn', true, { root: true });
              if ('province' in userProfile) {
                commit('profileState', userProfile, { root: true });
                vm.$toasted.global.show('Login Successful. Welcome!');
                // Content.basicProfile({});
                if (vm.$store.state.nextURL) {
                  window.location.replace(vm.$store.state.nextURL);
                } else if (vm.$store.state.redirectUrl) {
                  vm.$router.push(vm.$store.state.redirectUrl);
                  commit('redirectUrl', '');
                } else {
                  vm.$router.push('/');
                }
              } else {
                vm.$router.push('/register-detail');
              }
            } else {
              vm.$toasted.global.show('Verifikasi berhasil');
              axios.get(Config.MS_ACCOUNTS_API_URL + '/user/me').then((response) => {
                commit('userProfile', response.data.data, { root: true });
                vm.$router.push('/');
              });
            }
          }
          if (state.scope === 'registered_sociolla_store') {
            vm.$toasted.global.show('Verifikasi berhasil');
            axios.get(Config.MS_ACCOUNTS_API_URL + '/user/me').then((response) => {
              commit('userProfile', response.data.data, { root: true });
              if (vm.submitOtpCallback) {
                vm.submitOtpCallback();
              }
            });
          }
          commit('setIsOtpVerified', true);
        }
      });
    },
    async submitForget({ commit, state, dispatch, rootState }) {
      commit('changeIsCorrectNumber', true);
      commit('setOtpScope', 'forget-password');
      if (state.forgetPassword.mode === 'email') {
        dispatch('verifyEmail', state.forgetPassword.email).then((response) => {
          if (response) {
            dispatch('sendOtp').then((success) => {
              if (success) {
                if (rootState.modal.isModalShow.forgetPassword) {
                  commit('toggleModalGlobalState', { modalName: 'forgetPassword' }, { root: true });
                }
                if (!rootState.loggedin) {
                  commit('setEmailSuccess', true);
                  this._vm.$SO('#app').addClass('noscroll');
                  return;
                }
                this._vm.$toasted.global.show(
                  'Anda telah menerima email yang berisi link untuk mengatur ulang password. <strong>Cek email Anda</strong>'
                );
              }
            });
          }
        });
      }
      if (state.forgetPassword.mode === 'phone') {
        commit('setOtpMethod', '');
        const phone_no = state.forgetPassword.phone;
        const phone_code =
          (rootState.otp && rootState.otp.userCountry && rootState.otp.userCountry.phone_code) || '+62';
        dispatch('verifiedPhoneCheck', { phone_no, phone_code }).then((validated) => {
          if (validated) {
            // if in login page show verification modal
            if (rootState.modal.isModalShow.forgetPassword) {
              commit('toggleModalGlobalState', { modalName: 'forgetPassword' }, { root: true });
            }
            if (!rootState.loggedin) {
              commit(
                'setDataModal',
                {
                  modalName: 'loginPage',
                  value: 4,
                },
                { root: true }
              );
              if (
                Object.keys(state.userCountry).length &&
                state.userCountry.phone_code !== '+62' &&
                state.userCountry.phone_code !== '+84'
              ) {
                // dispatch('selectOtpMethod', 'whatsapp');
                commit('setOtpMethod', 'whatsapp');
                commit('setIsOtpSent', true);
                dispatch('sendOtp');
              }
            } else {
              // show verification modal
              commit('toggleModalGlobalState', { modalName: 'otpCode' }, { root: true });
              if (
                Object.keys(state.userCountry).length &&
                state.userCountry.phone_code !== '+62' &&
                state.userCountry.phone_code !== '+84'
              ) {
                // dispatch('selectOtpMethod', 'whatsapp');
                commit('setOtpMethod', 'whatsapp');
                commit('setIsOtpSent', true);
                dispatch('sendOtp');
              }
            }
          }
        });
      }
    },
    async submitOfflineRegist({ commit, state, dispatch, rootState }) {
      commit('changeIsCorrectNumber', true);
      commit('setOtpScope', 'registered_sociolla_store');
      if (state.offlineRegist.mode === 'phone') {
        commit('setOtpMethod', '');
        const phone_no = state.offlineRegist.phone;
        const phone_code = (rootState.otp.userCountry && rootState.otp.userCountry.phone_code) || '+62';
        dispatch('verifiedPhoneCheckOfflineRegist', { phone_no, phone_code }).then((validated) => {
          if (validated) {
            commit(
              'setDataModal',
              {
                modalName: 'loginPage',
                value: 4,
              },
              { root: true }
            );
            if (!rootState.loggedin) {
              if (
                Object.keys(state.userCountry).length &&
                state.userCountry.phone_code !== '+62' &&
                state.userCountry.phone_code !== '+84'
              ) {
                commit('setOtpMethod', 'whatsapp');
                commit('setIsOtpSent', true);
                dispatch('sendOtp');
              }
            } else {
              // show verification modal
              commit('toggleModalGlobalState', { modalName: 'otpCode' }, { root: true });
              if (
                Object.keys(state.userCountry).length &&
                state.userCountry.phone_code !== '+62' &&
                state.userCountry.phone_code !== '+84'
              ) {
                commit('setOtpMethod', 'whatsapp');
                commit('setIsOtpSent', true);
                dispatch('sendOtp');
              }
            }
            // commit('toggleModalGlobalState', { modalName: 'offlineRegistration' }, { root: true });
          } else {
            this._vm.$toasted.global.error(
              'Phone number that you entered is not correct? Make sure you change with the one you used to register at the Sociolla Store.'
            );
          }
        });
      }
    },
    verifyEmail({ state }, email) {
      return axios
        .post(`${Config.MS_SOCO_PUBLIC_API_URL}/auth/email/check`, {
          email: email,
        })
        .then((response) => {
          if (!response.data.data && state.scope === 'forget-password') {
            this._vm.$toasted.global.error('Email is not registered');
            return false;
          }
          return response.data.data;
        });
    },
    fetchCountry({ state, dispatch, commit, rootState }) {
      if (state.country.length) {
        return;
      }
      const params = {
        filter: {
          is_active: true,
        },
        skip: 0,
        limit: 0,
        sort: 'name',
      };
      return axios
        .get(Config.MS_SOCO_PUBLIC_API_URL + `/countries`, {
          params: params,
        })
        .then(function (response) {
          if (response.status === 200 && response.data.data) {
            // const countryData = response.data.data.filter((item) => item.is_active === true);
            commit('setCountry', response.data.data);
            if (response.data.data && response.data.data.length) {
              const countryCode = (rootState && rootState.userProfile && rootState.userProfile.phone_code) || '+62';
              if (!Object.keys(state.userCountry).length) {
                commit(
                  'saveCountry',
                  response.data.data.find((res) => res.phone_code === countryCode)
                );
              }
            } else {
              commit('saveCountry', {});
            }
          }
        })
        .catch((error) => {
          console.log(error);
          commit('setCountry', []);
          commit('saveCountry', {});
        });
    },
  },
  getters: {
    otpIntervalCount: (state) => state.interval.count,
    otpScope: (state) => state.scope,
    otpError: (state) => state.error,
    maxReached: (state) => state.maxReached,
    otpMethod: (state) => state.method,
    newChangeNumber: (state) => state.changeNumber.newNumber,
    forgetPassword: (state) => state.forgetPassword,
    verification: (state) => state.verification,
    offlineRegist: (state) => state.offlineRegist,
    phoneNumber: (state) => {
      if (state.scope === 'verification') {
        return state.verification.phone.charAt(0) === '0'
          ? state.verification.phone.substr(1)
          : state.verification.phone;
      }
      if (state.scope === 'forget-password') {
        return state.forgetPassword.phone.charAt(0) === '0'
          ? state.forgetPassword.phone.substr(1)
          : state.forgetPassword.phone;
      }
      if (state.scope === 'change-number') {
        return state.changeNumber.newNumber.charAt(0) === '0'
          ? state.changeNumber.newNumber.substr(1)
          : state.changeNumber.newNumber;
      }
      if (state.scope === 'quick-registration') {
        return state.quickRegistration.phone.charAt(0) === '0'
          ? state.quickRegistration.phone.substr(1)
          : state.quickRegistration.phone;
      }
      if (state.scope === 'registered_sociolla_store') {
        return state.offlineRegist.phone.charAt(0) === '0'
          ? state.offlineRegist.phone.substr(1)
          : state.offlineRegist.phone;
      }
      return '';
    },
    verificationAddress: (state, getters, rootState) => {
      let address = '';
      const userProfile = rootState.userProfile;
      if (state.scope === 'verification') {
        address =
          state.method === 'sms' || state.method === 'whatsapp' || !state.method
            ? // ? '+62' + getters.phoneNumber
              (userProfile && userProfile.phone_no_e164) ||
              ((userProfile && userProfile.phone_code) ||
                (rootState.otp && rootState.otp.userCountry && state.userCountry.phone_code)) + getters.phoneNumber
            : state.verification.email;
      }
      if (state.scope === 'change-number') {
        address = state.userCountry.phone_code
          ? `${state.userCountry.phone_code}${getters.phoneNumber}`
          : `+62${getters.phoneNumber}`;
      }
      if (state.scope === 'forget-password') {
        address =
          state.forgetPassword.mode === 'phone'
            ? `${state.userCountry.phone_code || '+62'}${getters.phoneNumber}`
            : state.forgetPassword.email;
      }
      if (state.scope === 'quick-registration') {
        address =
          state.quickRegistration.mode === 'phone'
            ? state.userCountry.phone_code
              ? state.userCountry.phone_code + getters.phoneNumber
              : '+62' + getters.phoneNumber
            : state.quickRegistration.email;
      }
      if (state.scope === 'registered_sociolla_store') {
        const number = getters.phoneNumber;
        let newNumber = null;
        if (number) {
          newNumber = number.charAt(0) === '0' ? number : '0' + number;
          let numberAccumulator = newNumber.split('').reduce((accumulator, current, idx, array) => {
            if (idx % 4 === 0 && idx > 0) {
              accumulator += '-';
            }
            accumulator += current;
            return accumulator;
          }, '');
          numberAccumulator = numberAccumulator.charAt(0) === '0' ? numberAccumulator.slice(1) : numberAccumulator;
          if (state.userCountry.phone_code) {
            newNumber = state.userCountry.phone_code + numberAccumulator;
          } else {
            newNumber = '+62' + numberAccumulator;
          }
        }
        address = newNumber;
      }
      return address;
    },
    formattedPhoneNumber: (state, getters) => {
      // const number = getters.phoneNumber
      // if (number) {
      //     // prefix
      //     const prefix = '0' + number.substr(0,2)
      //     // suffix
      //     const suffix = number.substr(-3)
      //     // middle
      //     let middle = number.substr(2, number.length - 5)
      //     let formattedMiddle
      //     const divider = middle.length % 3 === 0 ? 3 : 4
      //     if (middle.length > 5) {
      //         formattedMiddle = middle.split('').reduce((acc, _, idx) => {
      //             if (idx % divider === 0) {
      //                 acc += '-'
      //             }
      //             acc += '*'
      //             if (idx === middle.length - 1) {
      //                 acc += '-'
      //             }
      //             return acc
      //         }, '')
      //     }
      //     else {
      //         formattedMiddle = '-' + middle.replace(/\w/g, '*') + '-'
      //     }
      //     return prefix + formattedMiddle + suffix
      // }
      // return ''
      const number = getters.phoneNumber;
      if (number) {
        let newNumber = null;
        newNumber = number.charAt(0) === '0' ? number : '0' + number;
        let numberAccumulator = newNumber.split('').reduce((accumulator, current, idx, array) => {
          if (idx % 4 === 0 && idx > 0) {
            accumulator += '-';
          }
          accumulator += idx <= array.length - 4 && idx > 2 ? '*' : current;
          return accumulator;
        }, '');
        numberAccumulator = numberAccumulator.charAt(0) === '0' ? numberAccumulator.slice(1) : numberAccumulator;
        if (state.userCountry.phone_code) {
          newNumber = state.userCountry.phone_code + numberAccumulator;
        } else {
          newNumber = '+62' + numberAccumulator;
        }
        return newNumber;
      }
      return '';
    },
    formattedPhoneNumberWithoutCensor: (state, getters) => {
      const number = getters.phoneNumber;
      if (number) {
        const num = number.charAt(0) === '0' ? number.slice(1) : number;
        let suffixNum = '';
        if (num.slice(7).length > 5) {
          suffixNum = num
            .slice(7)
            .split('')
            .reduce((accumulator, current, idx) => {
              if (idx % 4 === 0 && idx > 0) {
                accumulator += '-';
              }
              accumulator += current;
              return accumulator;
            });
        } else {
          suffixNum = num.slice(7);
        }
        if (state.userCountry.phone_code) {
          state.userCountry.phone_code + num.substr(0, 3) + '-' + num.substr(3, 4) + '-' + suffixNum;
        } else {
          '+62' + num.substr(0, 3) + '-' + num.substr(3, 4) + '-' + suffixNum;
        }
      }
      return '';
    },
    smsEnabled: (state) => {
      // hide sms if country is not ID or VN
      if (state.userCountry.name != 'Indonesia' && state.userCountry.name != 'Vietnam') {
        return false;
      }
      const sms = state.enableCheck.result.find((res) => res.feature_name === 'otp_sms');
      return sms ? sms.isToggleOn : false;
    },
    whatsappEnabled: (state) => {
      const whatsapp = state.enableCheck.result.find((res) => res.feature_name === 'otp_whatsapp');
      return whatsapp ? whatsapp.isToggleOn : false;
    },
    emailEnabled: (state) => {
      const email = state.enableCheck.result.find((res) => res.feature_name === 'otp_email');
      return email ? email.isToggleOn : false;
    },
  },
};
